{
  "en": {
    "aiCategories": {
      "categories": {
        "all": "All",
        "character": "Personas",
        "communication": "Organisation",
        "content": "Differentiate",
        "featured": "New",
        "feedback": "Assessment",
        "inspiration": "Inspiration",
        "material": "Materials",
        "model": "AI Model",
        "null": "Uncategorized",
        "planning": "Planning",
        "plugin": "Plugin",
        "pupils": "For Students",
        "teachers": "For Teachers",
        "document_qa": "Document Assistant",
        "undefined": "Uncategorized"
      },
      "personaCategories": {
        "famousMen": "Famous Men",
        "famousWomen": "Famous Women",
        "funny": "Funny"
      },
      "subcategories": {
        "pupils": {
          "exercises": "Exercises and Learning Aids",
          "inspiration": "Inspiration and Creativity",
          "roleplay": "Simulations and Roles"
        },
        "teachers": {
          "feedback": "Feedback and Assessment",
          "information": "Information and Guidance",
          "inspiration": "Inspiration and Creativity",
          "material": "Materials and Assignments",
          "administration": "School Administration and Organisation",
          "planning": "Lesson Planning and Organization"
        }
      }
    }
  }
}
